<template>
  <!-- 罪名库列表 -->
  <div class="zuiminlist">
    <div class="cont between">
      <div class="left">
        <zuiminlb class="zmlb1" :colId='colId'></zuiminlb>
        <zuiminjxwd class="mt30 zmjxhd1" />
      </div>
      <div class="right">
        <zuimintj class="zmtj1" />
        <zuimintj
          class="zmtj1 mt30"
          tjtitle="刑事辩护相关知识"
          :xhnum="5"
          moniwx="盗窃18万量刑标准是怎样的"
        />
        <zmkssealaw class="zmsea mt30" />
        <tiaolionline class="onlinezx mt30" titext="在线咨询刑事辩护专业律师" />
        <zmgzraank class="zmrank mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import zuiminlb from "./child/zuiminlb";
import zuiminjxwd from "./child/zuiminjxwd";
import zuimintj from "./components/zuimintj";
import zmkssealaw from "./components/zmkssealaw";
import zmgzraank from "./components/zmgzraank";
import tiaolionline from "views/tiaoliifyul/components/tiaolionline";
export default {
  components: {
    zuiminlb,
    zuiminjxwd,
    zuimintj,
    zmkssealaw,
    zmgzraank,
    tiaolionline,
  },
  data(){
    return {
      colId:this.$route.query.colid
    }
  }
};
</script>

<style lang="scss" scoped>
.zuiminlist {
  background: #f8f8f8;
  .cont {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    align-items: flex-start;
    .left {
      width: 856px;
      .zmlb1 {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 2px;
      }
      .zmjxhd1 {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 2px;
      }
    }
    .right {
      width: 314px;
      .zmtj1 {
        width: 100%;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      .zmsea {
        width: 100%;
        height: 195px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      .onlinezx {
        width: 314px;
        height: 316px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
      .zmrank {
        width: 100%;
        height: 483px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>